module.exports = __webpack_public_path__ + "img/11.5eedd2a7.png";